import { Input, Table } from "antd";
import { formatVND } from "../../helpers/common";
import Column from "antd/es/table/Column";
import ColumnGroup from "antd/es/table/ColumnGroup";

const TableThuLaoNDD = ({ isLoading, dataTable, trangThai, loaiDanhGia, onChange, isEdit }: { isLoading: boolean, dataTable: Array<any>, trangThai: number, loaiDanhGia: boolean, onChange?: (dataTable: any) => any, isEdit: boolean }) => {
    return (
        <Table
            loading={isLoading}
            dataSource={(dataTable || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
            locale={{ emptyText: "Không có dữ liệu" }}
            pagination={false}
            bordered={true}
            sticky
            summary={pageData => {
                let totalTongMucThuLao = 0;
                let totalThuLaoDuocNhan = 0;
                let dataQuy: number[] = [];
                pageData.forEach(({ tongMucThuLao, thuLaoDuocNhan, chiTietCaNam }) => {
                    totalTongMucThuLao += tongMucThuLao;
                    totalThuLaoDuocNhan += thuLaoDuocNhan;

                    chiTietCaNam?.forEach((item: any, idx: number) => {
                        if (dataQuy.length - 1 < idx) {
                            dataQuy.push(0);
                        }

                        dataQuy[idx] += item.mucThuLaoTong;
                    });
                });
                var thang = 0;
                if ((pageData || []).length > 0) {
                    thang = (pageData[0].chiTietDaNhan || []).length;
                }
                return (
                    <>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={1} colSpan={3} align="center"><label>Tổng cộng</label> </Table.Summary.Cell>
                            {dataQuy.length > 0 &&
                                <>
                                    {dataQuy.map((item: number, idx: number) => (
                                        <Table.Summary.Cell key={item.toString() + idx.toString()} index={4 + idx} align="right"><label> {formatVND(item)}</label></Table.Summary.Cell>
                                    ))}
                                    <Table.Summary.Cell index={1 + dataQuy?.length} align="center"></Table.Summary.Cell>
                                </>
                            }
                            <Table.Summary.Cell index={2 + dataQuy?.length + 1} align="center"><label>{formatVND(totalTongMucThuLao)}</label></Table.Summary.Cell>
                            <Table.Summary.Cell index={3 + dataQuy?.length + 1} align="center"><label>{formatVND(totalThuLaoDuocNhan)}</label></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </>
                );
            }}
        >
            <Column title="Họ tên" key="ten" dataIndex="ten" />
            <Column title="Công ty" key="congTy" dataIndex="congTy" />
            <Column title="Chức vụ" key="chucVu" dataIndex="chucVu" />
            {
                (dataTable.length > 0 && dataTable[0]?.chiTietCaNam?.length > 0 && <ColumnGroup key={dataTable[0].id} title="Thù lao NĐD Công ty góp vốn chuyển về Quỹ">
                    {(dataTable[0].chiTietCaNam || []).map((item: any, idx: number) => {
                        let title = item.tenChiTiet
                        let key = item.tenChiTiet
                        return (
                            <Column key={item.tenChiTiet + idx} title={title} className="custom-column" render={(value, record, index) => {
                                return (
                                    <>{formatVND(value.chiTietCaNam[idx]?.mucThuLaoTong || 0)}</>
                                )
                            }} />
                        )
                    })}
                </ColumnGroup>)
            }
            {loaiDanhGia &&
                <Column title="Tỷ lệ đánh giá (đơn vị: %)" key="phanTramDanhGia" dataIndex="phanTramDanhGia" render={(value, record: any, idx) => {
                    return isEdit ? <Input readOnly={trangThai > 0} key={"phanTramDanhGia" + idx} value={record.phanTramDanhGia || 0} onChange={(e) => {
                        let tongMucThuLaoTong: number = 0;
                        for (let i = 0; i < dataTable[idx].chiTietCaNam.length; i++) {
                            tongMucThuLaoTong += dataTable[idx].chiTietCaNam[i].mucThuLaoTong;
                        }
                        dataTable[idx].phanTramDanhGia = parseInt((e.target.value || "").replace(/[^0-9]/g, '').trim().replace(/^0+/, '')) || 0;
                        dataTable[idx].tongMucThuLao = dataTable[idx].phanTramDanhGia * tongMucThuLaoTong / 100;
                        dataTable[idx].thuLaoDuocNhan = dataTable[idx].tongMucThuLao - tongMucThuLaoTong / 2;
                        if (onChange) {
                            onChange([...dataTable])
                        }
                    }} /> : <>{record.phanTramDanhGia || 0}</>
                }} />
            }
            <Column title="Tổng mức thù lao" key="tongMucThuLao" dataIndex="tongMucThuLao" render={(value, record: any, idx) => {
                return isEdit ?  < Input readOnly = { trangThai > 0
            } key={"tongMucThuLaoKey" + idx} value={formatVND(record.tongMucThuLao || 0).replace('₫', '').trim()} onChange={(e) => {
                    dataTable[idx].tongMucThuLao = parseInt((e.target.value || "").replace(/[^0-9]/g, '').trim().replace(/^0+/, '')) || 0;
                    dataTable[idx].thuLaoDuocNhan = Math.round(dataTable[idx].tongMucThuLao * 0.5);
                    if (onChange) {
                        onChange([...dataTable])
                        }
                    }} /> : <>{formatVND(record.tongMucThuLao)}</>
            }} />

            <Column title="Thù lao được nhận" key="thuLaoDuocNhan" dataIndex="thuLaoDuocNhan" render={(value, record: any, idx) => {
                return isEdit ? <Input readOnly={trangThai > 0} key={"thuLaoDuocNhanKey" + idx} value={formatVND(record.thuLaoDuocNhan || 0).replace('₫', '').trim()} onChange={(e) => {
                    dataTable[idx].thuLaoDuocNhan = parseInt((e.target.value || "").replace(/[^0-9]/g, '').trim().replace(/^0+/, '')) || 0;
                    if (onChange) {
                            onChange([...dataTable])
                    }
                }} /> : <>{formatVND(record.thuLaoDuocNhan)}</>
            }} />
        </Table>
    )
}

export default TableThuLaoNDD